import { HotjarConfigurationDisabled } from '@savgroup-front-common/core/src/components/HotjarProvider/HotjarProvider';

export default {
  enabled: false,
} as HotjarConfigurationDisabled;
